import { DataBox, createDataBox } from 'app/common/data-box-store'
import { SendersInfo } from 'app/dataTypes/transfer/senders'


const defaultSendersInfo: SendersInfo = {
  senders: [],
  activeSenders: [],
  hasActiveSenders: false,
}

class SendersInfoDataBox extends DataBox<SendersInfo> { }
export const sendersInfo = createDataBox('sendersInfo', defaultSendersInfo, SendersInfoDataBox)
